import { useSearchParams, useNavigate } from "react-router";
import { EmailComposer } from "@/components/email/email-composer";
import { Id } from "@convex/_generated/dataModel";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ComposeEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const blockId = searchParams.get("blockId") as Id<"blocks"> | null;
  const subject = searchParams.get("subject") ?? undefined;
  const replyTo = searchParams.get("replyTo") ?? undefined;
  const replyToName = searchParams.get("replyToName") ?? undefined;

  return (
    <div className="min-h-screen bg-background">
      <div className="sticky top-0 z-10 bg-background border-b px-4 pt-safe pb-3 flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <h1 className="text-lg font-semibold">{replyTo ? "Reply" : "New Email"}</h1>
      </div>
      <EmailComposer
        blockId={blockId ?? undefined}
        defaultSubject={subject}
        defaultRecipientEmail={replyTo}
        defaultRecipientName={replyToName}
        onSent={() => navigate("/email")}
      />
    </div>
  );
}
